import React from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { IoIosInformationCircleOutline as InfoIcon } from "react-icons/io";

const DailyHeavyLosses = ({
  handleChange,
  configDetails,
  dailyHeavyLossAvgSoft,
  setDailyHeavyLossAvgSoft,
  dailyHeavyLossAvgHard,
  setDailyHeavyLossAvgHard,
}) => {
  return (
    <div className="mt-3 w-100 ps-3 card-style">
      {/* Header */}
      <div className="d-flex justify-content-between w-100">
        <h4 className="w-50 fw-bold">
          Daily Heavy Losses{" "}
          <Tippy
            theme="light"
            content="Protect players from losing heavily during a full day |

            Average Daily GGR Multiplier - Set how many times higher a players max net loss can be above their average daily net loss before triggering an intervention"
            arrow={false}
          >
            <span>
              <InfoIcon
                size="14"
                color="var(--secondary-blue)"
                className=" position-absolute translate-middle-y"
              />
            </span>
          </Tippy>
        </h4>
      </div>

      {/* Average Daily GGR Multiplier */}
      <div className="d-flex justify-content-between w-100 align-items-center mb-3">
        <p style={{ marginBottom: "0" }} className="w-50">
          Average Daily GGR Multiplier
        </p>
        <div className="d-flex align-items-center w-50">
          <div className="w-50 d-flex justify-content-center">
            <input
              type="number"
              name="dailyHeavyLossAvgSoft"
              value={configDetails.dailyHeavyLossAvgSoft}
              // defaultValue={dailyHeavyLossAvgSoft}
              onChange={handleChange}
              className="form-control inpt-option"
            />
          </div>
          <div className="w-50 d-flex justify-content-center">
            <input
              type="number"
              name="dailyHeavyLossAvgHard"
              value={configDetails.dailyHeavyLossAvgHard}
              // defaultValue={dailyHeavyLossAvgHard}
              onChange={handleChange}
              className="form-control inpt-option"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DailyHeavyLosses;
